// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__15nwD","left":"StickyBox_left__1KQN3","right":"StickyBox_right__1gKMO"};